import NotificationItem, { LeadingAvatar, Nickname } from 'components/notification/NotificationItem';
import type { Notification } from 'types/notification';
import { insertComponent } from 'utils/i18nUtils';

const TEXT_KEY: Record<string, string> = {
  missedCall: 'notification_missed_call',
  makeFriend: 'notification_friend_request',
};

const CallButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <img src="/imgweb/main/ic_video_gradient.svg" className="h-10 w-10" alt="" onClick={onClick} />
);

const ChatButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#6200EE]" onClick={onClick}>
    <img src="/imgweb/chat/ic_chat_white.svg" className="h-[22px] w-[22px]" alt="" />
  </div>
);

interface AlertItemProps {
  item: Notification;
  showUnreadHeader?: boolean;
  onAvatarClick: () => void;
  onActionClick: () => void;
}

const AlertItem: React.FC<AlertItemProps> = ({ item, showUnreadHeader, onAvatarClick, onActionClick }) => {
  // 상대를 못 찾은 알림은 notificationService 가 목록에서 빼므로 여기까지 오지 않는다.
  const sender = item.sender;
  if (!sender) return null;

  return (
    <NotificationItem
      unread={item.unread}
      showUnreadHeader={showUnreadHeader}
      createdTime={item.createdTime}
      leading={
        <span onClick={onAvatarClick}>
          <LeadingAvatar user={sender} />
        </span>
      }
      content={insertComponent(brsc[TEXT_KEY[item.subtype]], <Nickname user={sender} />)}
      trailing={item.subtype === 'missedCall' ? <CallButton onClick={onActionClick} /> : <ChatButton onClick={onActionClick} />}
    />
  );
};

export default AlertItem;
